import { render, staticRenderFns } from "./Dashboard_DIR.vue?vue&type=template&id=a518a320&scoped=true&"
import script from "./Dashboard_DIR.vue?vue&type=script&lang=js&"
export * from "./Dashboard_DIR.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_DIR.vue?vue&type=style&index=0&id=a518a320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a518a320",
  null
  
)

export default component.exports